import { render, staticRenderFns } from "./advertisers.vue?vue&type=template&id=b388effe&"
import script from "./advertisers.vue?vue&type=script&lang=js&"
export * from "./advertisers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports